//Custom Code Injected Start---//

var MenuGenerator = "";
var MenuformatVal = "menuboard_16-9";
var MenuformatPerY = 56.25;
var OutPutFormatVal = "JPG";
var isResolutionChangeVal = true;
var MenuImageSrc = "";

//Custom Code Injected End---//

function menuGenSliderOptions(index) {
    var options = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: index,
        rows: 0,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                },
            },
        ],
    };
    // console.log("options :>> ", options);
    return options;
}

function stringTranslation(stringVar) {
    var only_numbers = "Chiffre uniquement";

    return eval(stringVar);
}

function resizeBoxEl(el) {
    var logoTextBoxEl = $(".logo-text-box");
    var menuPriceBoxEl = $(".menu-price-box");
    // var wrapperWidth = $('.format-display-val').width();
    var wrapperWidth = $(".menu-preview-box").width();
    var wrapper_initial_width = 710;

    var newElWidth = wrapperWidth / wrapper_initial_width;
    if (el === "print_a4" || el === "just_eat_1-1") {
        newElWidth = newElWidth * 1.5;
    }
    if (wrapperWidth < 600) {
        logoTextBoxEl.css({
            transform: "scale(" + newElWidth + ")",
        });
    }
}

function getSlidIndexBySlideId(slideId, slideList) {
    var el;

    for (let i = 0; i < slideList.length; i++) {
        if (slideList[i].id === slideId) {
            el = slideList[i];
            el.index = i;
            break;
        }
    }

    return el.index;
}

$(document).ready(function () {
    resizeBoxEl();

    // Initialize all sliders
    $("#background-image-slider").slick(menuGenSliderOptions(5));
    $("#surface-image-slider").slick(menuGenSliderOptions(0));
    $("#dish-image-slider").slick(menuGenSliderOptions(1));
    $("#snack-image-slider").slick(menuGenSliderOptions(1));
    $("#drink-image-slider").slick(menuGenSliderOptions(1));
    $("#logo-image-slider").slick(menuGenSliderOptions(1));
    $("#second-logo-image-slider").slick(menuGenSliderOptions(1));

    startSliders(["background-image-slider", "surface-image-slider"]);
});

function jQueryMarkSelectedImage(el, sliderId) {
    $("#" + sliderId + " .bis-item").removeClass("active");
    el.classList.add("active");
}

function startSliders(ids) {
    for (var i = 0; i < ids.length; i++) {
        var elId = ids[i];
        var slideStartIndex;

        // unslick / destroy a each slick instance
        $("#" + elId).slick("unslick");


        switch (elId) {
            case "background-image-slider":
                slideStartIndex = getSlidIndexBySlideId(backgoundImageId, backgoundImageList);
                break;
            case "surface-image-slider":
                slideStartIndex = getSlidIndexBySlideId(surfaceImageId, surfaceImageList);
                break;
            case "dish-image-slider":
                // -1 because first element in array is empty/delete-image
                slideStartIndex = getSlidIndexBySlideId(dishId, dishList) - 1;
                break;
            case "snack-image-slider":
                // -1 because first element in array is empty/delete-image
                slideStartIndex = getSlidIndexBySlideId(snackId, snackList) - 1;
                break;
            case "drink-image-slider":
                // -1 because first element in array is empty/delete-image
                slideStartIndex = getSlidIndexBySlideId(drinkId, drinkList) - 1;
                break;
            case "logo-image-slider":
                // -2 because first element in array is empty/delete-image and second element is upload custom logo
                slideStartIndex = getSlidIndexBySlideId(logoId, logoList) - 2;
                break;
            case "second-logo-image-slider":
                slideStartIndex = getSlidIndexBySlideId(secondLogoId, logoList) - 2;
                break;
            default:
                slideStartIndex = 0;
        }

        // initiate each slick instance with updated settings - initialSlide
        $("#" + elId).slick(menuGenSliderOptions(slideStartIndex));
    }
}

function downloadFile(url, fileExtension) {
    var link = document.createElement("a");
    link.href = url;
    link.download = "menu." + fileExtension;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

var menuGeneratorVue = new Vue({
    el: "#PFS_menuGenerator",
    mixins: [dragResizeElementsMixin, subCategoriesFilteringMixin],

    data() {
        return {
            tab: "subscribe",

            // Background images
            backgoundImageList: window.backgoundImageList,
            backgoundImageId: window.backgoundImageId,
            selectedBackgroundImageURL: null,

            // Surface images
            surfaceImageList: window.surfaceImageList,
            surfaceImageId: window.surfaceImageId,
            selectedSurfaceImageURL: null,

            // Dish images
            dishList: window.dishList,
            dishId: window.dishId,
            selectedDishImageURL: null,
            selectedDishName: null,

            // Drink images
            drinkList: window.drinkList,
            drinkId: window.drinkId,
            selectedDrinkImageURL: null,
            selectedDrinkName: null,

            // Snack images
            snackList: window.snackList,
            snackId: window.snackId,
            selectedSnackImageURL: null,
            selectedSnackName: null,

            // Logo images
            logoList: window.logoList,
            logoId: window.logoId,
            secondLogoId: window.secondLogoId,
            selectedLogoImageURL: null,
            selectedSecondLogoImageURL: null,

            format: window.format,
            formatMask: null,

            menuHeadline: window.menuHeadline,
            menuText: window.menuText,
            menuPrice: window.menuPrice,
            menuPriceRules: {
                numeric: function numeric(v) {
                    const pattern = /^[0-9.,]*$/;
                    return pattern.test(v) || stringTranslation("only_numbers");
                },
            },
            includeMenuDescription: window.includeMenuDescription,

            fileType: window.fileType,

            mealSnackbar: false,
            fileForDownload: null,
            isLoading: false,

            menuName: window.menuName,
            openNameDialog: false,
            menuNameRules: [(v) => !!v || "Menu name is required"],
            isFormValid: true,
            saveDraftErrorMsg: "",
            showErrorSnackbar: false,
            isDraftSaveActive: false,

            isInitialCalculateFormat: true,
        };
    },

    methods: {
        selectBackground(e) {
            this.markSelectedImage(e.currentTarget, "background-image-slider", "backgoundImageId", "backgroundImageId");
        },
        selectSurface(e) {
            this.markSelectedImage(e.currentTarget, "surface-image-slider", "surfaceImageId", "surfaceImageId");
        },
        selectDish(e) {
            this.markSelectedImage(e.currentTarget, "dish-image-slider", "dishId", "dishImageId");
        },
        selectSnack(e) {
            this.markSelectedImage(e.currentTarget, "snack-image-slider", "snackId", "snackImageId");
        },
        selectDrink(e) {
            this.markSelectedImage(e.currentTarget, "drink-image-slider", "drinkId", "drinkImageId");
        },
        selectLogo(e) {
            this.markSelectedImage(e.currentTarget, "logo-image-slider", "logoId", "logoImageId");
        },
        selectSecondLogo(e) {
            this.markSelectedImage(e.currentTarget, "second-logo-image-slider", "secondLogoId", "secondLogoImageId");
        },

        markSelectedImage(el, sliderId, typeId, dataId) {
            const requiredIdsList = [this.dishId, this.drinkId, this.snackId];
            const dataValue = el.dataset[dataId];

            if (dataValue === "upload_custom_logo_2") {
                // Mark clicked item
                jQueryMarkSelectedImage(el, sliderId);

                this.selectedSecondLogoImageURL = dataValue;

                // Click on hidden upload input form
                // this.$refs.custom_logo_input.click();
            } else if (dataValue === "upload_custom_logo") {
                // Mark clicked item
                jQueryMarkSelectedImage(el, sliderId);

                // Click on hidden upload input form
                this.$refs.custom_logo_input.click();
            } else if (dataValue === "0") {
                if (sliderId === 'second-logo-image-slider') {
                    this.selectedSecondLogoImageURL = null;
                }

                if (!requiredIdsList.includes("0")) {
                    jQueryMarkSelectedImage(el, sliderId);
                    this[typeId] = dataValue;
                } else {
                    // Hide logo independently from rest of elements
                    if (typeId === "logoId") {
                        this[typeId] = dataValue;
                    }
                    this.mealSnackbar = true;
                }
            } else {
                jQueryMarkSelectedImage(el, sliderId);
                this[typeId] = dataValue;
            }
        },
        getSelectedImageURL(list, id, elString) {
            const image = JSON.parse(JSON.stringify(list)).find((obj) => {
                return parseInt(obj.id) === parseInt(id);
            });
            this[elString] = image.prev_url;
        },
        getSelectedElementName(list, id, elString) {
            const element = JSON.parse(JSON.stringify(list)).find((obj) => {
                return parseInt(obj.id) === parseInt(id);
            });

            this[elString] = element.name;
        },

        markAsActiveElementById(prefix, id) {
            const refString = prefix + id;

            this.$refs[refString].classList.add("active");
        },

        startInTabSliders(ids) {
            startSliders(ids);
        },
        formatCalc(a, b) {
            return (b / a) * 100;
        },
        calculateFormat(formatVal) {

            let val = 0;
            MenuformatVal = formatVal; //Custom Code Injected---//
            switch (formatVal) {
                case "print_a4":
                    val = this.formatCalc(1, 1.4142);
                    break;
                case "menuboard_16-9":
                    val = this.formatCalc(16, 9);
                    break;
                case "deliveroo_hero_image_16-9":
                    val = this.formatCalc(16, 9);
                    break;
                case "deliveroo_product_image_4-3":
                    val = this.formatCalc(4, 3);
                    break;
                case "just_eat_1-1":
                    val = this.formatCalc(1, 1);
                    break;
                case "uber_eats_6-4":
                    val = this.formatCalc(6, 4);
                    break;
                case "instagram_size_4-5":
                    val = this.formatCalc(4, 5);
                    break;
                default:
                    this.formatMask = 0;
            }
            MenuformatPerY = val; //Custom Code Injected---//
            this.formatMask = val + "%";

            // ----------------------------------------------------------------------------------------------------------------
            // Text box position and size
            // ----------------------------------------------------------------------------------------------------------------
            // On every format change reset text box position and size
            this.resetTextBoxPositionSize();
            this.resetPriceBoxPosition();

            // After format is calculated and view is changed - prepare for jQuery UI
            this.$nextTick(function () {
                // Function from mixin - menu-generator-drag-resize-element-mixin.js
                this.callDragResizeJS();
            });
            // ----------------------------------------------------------------------------------------------------------------

            this.setStartPositionForAllDraggableResizableElements();
            this.isInitialCalculateFormat = false;

            // Helper square
            // setTimeout(function () {
            //     calculateHelperSquare()
            // }, 300)

        },
        setStartPositionForAllDraggableResizableElements() {
            // Set absolute position on objects on next format change
            if (!this.isInitialCalculateFormat) {
                setStartPositionForAllDraggableResizableElements();
            }
        },
        dataForSending() {
            return {
                fileType: this.fileType,
                backgoundImageId: this.backgoundImageId,
                surfaceImageId: this.surfaceImageId,
                dishId: this.dishId,
                snackId: this.snackId,
                drinkId: this.drinkId,
                format: this.format,
                logoId: this.logoId,
                secondLogoId: this.secondLogoId,
                menuHeadline: this.menuHeadline,
                menuText: this.menuText,
                menuPrice: this.menuPrice,
                menuName: this.menuName,
                includeMenuDescription: this.includeMenuDescription,
                textBoxPositionSize: this.textBox,
                priceBoxPosition: this.priceBox,
            };
        },

        printDownload() {
            const data = JSON.stringify(this.dataForSending());
            this.isLoading = true;
            const _this = this;

            jQuery
                .ajax({
                    type: "POST",
                    url: window.print_download_url,
                    data: data,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                })
                .done(function () {
                    console.log(" success");
                })
                .fail(function (err) {
                    console.log("error: ", err);
                })
                .always(function () {
                    console.log("finished printDownload");
                    setTimeout(function () {
                        _this.isLoading = false;
                        _this.fileForDownload = "assets/menu-generator/file-to-download.jpg";
                        downloadFile(_this.fileForDownload, this.fileType);
                    }, 2000);
                });
        },

        saveDraft() {
            const data = JSON.stringify(this.dataForSending());
            const _this = this;
            // _this.isDraftSaved = false;
            _this.isDraftSaveActive = false;
            // :disabled="!menuName"
            jQuery
                .ajax({
                    type: "POST",
                    url: window.save_draft_url,
                    data: data,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                })
                .done(function (res) {
                    if (res.status === "success") {
                        _this.openNameDialog = false;
                    } else {
                        _this.isDraftSaveActive = true;
                    }
                })
                .fail(function (err) {
                    console.log("error dd: ", err);
                })
                .always(function () {
                    console.log("finished saveDraft");
                    _this.isDraftSaveActive = true;
                });
        },

        //--Custom code Injected Start

        dataForSendingSaveDraft() {
            return (MenuGenerator = {
                MenuName: this.menuName,
                Format: this.format,
                BackgoundImageID: $("#hdnBackgroundImageId").val(),
                SurfaceImageID: $("#hdnSurfaceImageId").val(),
                DishImageID: $("#hdnDishImageId").val(),
                SnackImageID: $("#hdnSnackImageId").val(),
                DrinkImageID: $("#hdnDrinkImageId").val(),
                LogoImageID: $("#hdnLogoImageId").val(),
                Headline: this.menuHeadline,
                Text: this.menuText,
                Price: this.menuPrice,
                IncludeMenuDescription: this.includeMenuDescription,
                UserID: $("#hdnUserId").val(),
                Json: "",
                S3ImageUrl: MenuImageSrc,
                TextBoxPositionSize: JSON.stringify(this.textBox),
                PriceBoxPosition: JSON.stringify(this.priceBox)
                // Text
            });
        },

        //--Custom code Injected Start

        // dataForSendingSaveDraft() {
        //     return (MenuGenerator = {
        //         MenuName: this.menuName,
        //         Format: this.format,
        //         BackgoundImageID: $("#hdnBackgroundImageId").val(),
        //         SurfaceImageID: $("#hdnSurfaceImageId").val(),
        //         DishImageID: $("#hdnDishImageId").val(),
        //         SnackImageID: $("#hdnSnackImageId").val(),
        //         DrinkImageID: $("#hdnDrinkImageId").val(),
        //         LogoImageID: $("#hdnLogoImageId").val(),
        //         Headline: this.menuHeadline,
        //         Text: this.menuText,
        //         Price: this.menuPrice,
        //         IncludeMenuDescription: this.includeMenuDescription,
        //         UserID: $("#hdnUserId").val(),
        //         Json: "",
        //         S3ImageUrl: MenuImageSrc,
        //         TextBoxPositionSize: JSON.stringify(this.textBox),
        //         PriceBoxPosition: JSON.stringify(this.priceBox)
        //     });
        // },
        printDownloadCropImage() {
            this.isLoading = true;
            var _this = this;

            let uiResizableHandle = document.getElementsByClassName("ui-resizable-handle");

            // Hide .ui-resizable-handle before printing image/pdf
            uiResizableHandle[0].classList.add("hidden");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gtm.linkClick',
                'dlv.action': 'Download',
                'dlv.type': 'Menu Generator',
                'dlv.title': this.menuHeadline,
                'dlv.snack': getFilenameFromPath(this.selectedSnackImageURL),
                'dlv.drink': getFilenameFromPath(this.selectedDrinkImageURL),
                'dlv.brand': getFilenameFromPath(this.selectedLogoImageURL),
            });

            let menuCrop = document.getElementById("menu-crop");
            // let menuCrop = document.getElementById("menu_preview");


            let date = new Date();
            let timestamp =
                date.getFullYear().toString() +
                (date.getMonth() + 1).padLeft() +
                date.getDate().toString() +
                "_" +
                date.getMinutes().toString() +
                date.getSeconds().toString();

            if (this.fileType == "jpg") {

                kendo.drawing
                    .drawDOM("#menu-crop", {
                        scale: GetScaleFactor(2000, 2000, menuCrop.offsetWidth, menuCrop.offsetHeight),
                    })
                    .then(function (group) {
                        return kendo.drawing.exportImage(group);
                    })
                    .done(function (data) {
                        // Save the image file
                        kendo.saveAs({
                            contentType: "image/png",
                            dataURI: data,
                            fileName: "Menu_" + timestamp + ".png",
                        });

                        // Show .ui-resizable-handle after printing image/pdf
                        uiResizableHandle[0].classList.remove("hidden");
                        _this.isLoading = false;

                    });
            } else {
                kendo.drawing
                    .drawDOM("#menu-crop", {
                        scale: GetScaleFactor(2000, 2000, menuCrop.offsetWidth, menuCrop.offsetHeight),
                    })
                    .then(function (group) {
                        // Render the result as a PDF file
                        return kendo.drawing.exportPDF(group, {
                            paperSize: "auto",
                        });
                    })
                    .done(function (data) {
                        // Save the PDF file
                        kendo.saveAs({
                            dataURI: data,
                            fileName: "Menu_" + timestamp + ".pdf",
                        });
                        // Show .ui-resizable-handle after printing image/pdf
                        uiResizableHandle[0].classList.remove("hidden");
                        _this.isLoading = false;
                    });
            }
            // Backup closing loader after 5 sec
            setTimeout(function () {
                _this.isLoading = false;
            }, 5000)

        },

        saveDraftNew: function saveDraftNew() {
            this.isLoading = true;
            var _this = this;
            this.openNameDialog = false;

            var dataMenu = this.dataForSendingSaveDraft();
            var menuPriceVal = this.menuPrice;
            var saveDraftMessage = "Success";
            let menuCrop = document.getElementById("menu-crop");

            let uiResizableHandle = document.getElementsByClassName("ui-resizable-handle");

            // Hide .ui-resizable-handle before printing image/pdf
            uiResizableHandle[0].classList.add("hidden");

            var _this = this;

            kendo.drawing
                .drawDOM("#menu-crop", {
                    scale: GetScaleFactor(400, 400, menuCrop.offsetWidth, menuCrop.offsetHeight),
                })
                .then(function (group) {
                    return kendo.drawing.exportImage(group);
                })
                .done(function (data) {
                    dataMenu.S3ImageUrl = data;

                    // Show .ui-resizable-handle after printing image/pdf
                    uiResizableHandle[0].classList.remove("hidden");

                    if ($("#hdnIsMenuUpdate").val() == "true") {
                        dataMenu.Id = $("#hdnMenuId").val();
                    }

                    jQuery
                        .ajax({
                            type: "POST",
                            url: url_savedraftmenu,
                            data: {
                                menugenerator: dataMenu,
                                menuPrice: menuPriceVal,
                                isMenuUpdate: $("#hdnIsMenuUpdate").val(),
                            },
                            dataType: "json",
                        })
                        .done(function (data) {
                            if (data.data != "Success") {
                                _this.saveDraftErrorMsg = data.data;
                                _this.showErrorSnackbar = true;
                            } else {
                                window.location.replace($("#hdnsavedrafturl").val());
                            }
                        })
                        .fail(function (err) {
                            console.log("error: ", err);
                            _this.saveDraftErrorMsg = "Une erreur technique est survenue.";
                            _this.showErrorSnackbar = true;
                        })
                        .always(function () {
                            console.log("finished saveDraft");
                            _this.isLoading = false;
                            this.openNameDialog = false;
                            // if (saveDraftMessage == "Success") {
                            // $(".menu-generator-message").html('<div class="v-messages__message message-transition-enter-to">' + saveDraftMessage + '</div>');
                            // window.location.replace($("#hdnsavedrafturl").val());
                            // }
                            // else {
                            //     $(".menu-generator-message").html('<div class="v-text-field__details"><div class="v-messages theme--light error--text" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message message-transition-enter-to">' + saveDraftMessage + '</div></div></div></div>');
                            // }
                        });
                });
        },
        updateDraft: function updateDraft() {
            this.isLoading = true;
            var _this = this;
            this.openNameDialog = false;

            var data = this.dataForSendingSaveDraft();
            var menuPriceVal = this.menuPrice;
            data.Id = $("#hdnMenuId").val();
            jQuery
                .ajax({
                    type: "POST",
                    url: url_updatedraftmenu,
                    data: {menugenerator: data, menuPrice: menuPriceVal},
                    dataType: "json",
                })
                .done(function () {
                    console.log("success");
                    window.location.replace($("#hdnsavedrafturl").val());
                })
                .fail(function (err) {
                    console.log("error: ", err);
                })
                .always(function () {
                    console.log("finished saveDraft");
                    _this.isLoading = false;
                });
        },

        //--Custom code Injected End
    },

    mounted() {
        // Background image
        this.getSelectedImageURL(this.backgoundImageList, this.backgoundImageId, "selectedBackgroundImageURL");

        // Surface image
        this.getSelectedImageURL(this.surfaceImageList, this.surfaceImageId, "selectedSurfaceImageURL");

        // Dish Image
        this.getSelectedImageURL(this.dishList, this.dishId, "selectedDishImageURL");
        this.getSelectedElementName(this.dishList, this.dishId, "selectedDishName");

        // Snack Image
        this.getSelectedImageURL(this.snackList, this.snackId, "selectedSnackImageURL");
        this.getSelectedElementName(this.snackList, this.snackId, "selectedSnackName");

        // Drink Image
        this.getSelectedImageURL(this.drinkList, this.drinkId, "selectedDrinkImageURL");
        this.getSelectedElementName(this.drinkList, this.drinkId, "selectedDrinkName");

        // Logo Image
        this.getSelectedImageURL(this.logoList, this.logoId, "selectedLogoImageURL");

        // Second Logo Image
        this.getSelectedImageURL(this.logoList, this.secondLogoId, "selectedSecondLogoImageURL");

        this.$nextTick(() => {
            this.markAsActiveElementById("background_image__", this.backgoundImageId);
            this.markAsActiveElementById("surface_image__", this.surfaceImageId);
            this.markAsActiveElementById("dish_image__", this.dishId);
            this.markAsActiveElementById("snack_image__", this.snackId);
            this.markAsActiveElementById("drink_image__", this.drinkId);
            this.markAsActiveElementById("logo_image__", this.logoId);
            this.markAsActiveElementById("second_logo_image__", this.secondLogoId);
        });

        this.calculateFormat(window.format);

    },
    watch: {
        backgoundImageId: {
            handler: function (val, oldVal) {
                this.getSelectedImageURL(this.backgoundImageList, val, "selectedBackgroundImageURL");
            },
            deep: true,
        },
        // surfaceImageId: {
        //     handler: function (val, oldVal) {
        //         this.getSelectedImageURL(this.surfaceImageList, val, "selectedSurfaceImageURL");
        //     },
        //     deep: true,
        // },
        // dishId: {
        //     handler: function (val, oldVal) {
        //         this.getSelectedImageURL(this.dishList, val, "selectedDishImageURL");
        //         this.getSelectedElementName(this.dishList, this.dishId, "selectedDishName");
        //     },
        //     deep: true,
        // },
        // snackId: {
        //     handler: function (val, oldVal) {
        //         this.getSelectedImageURL(this.snackList, val, "selectedSnackImageURL");
        //         this.getSelectedElementName(this.snackList, this.snackId, "selectedSnackName");
        //     },
        //     deep: true,
        // },
        // drinkId: {
        //     handler: function (val, oldVal) {
        //         this.getSelectedImageURL(this.drinkList, val, "selectedDrinkImageURL");
        //         this.getSelectedElementName(this.drinkList, this.drinkId, "selectedDrinkName");
        //     },
        //     deep: true,
        // },
        // logoId: {
        //     handler: function (val, oldVal) {
        //         this.getSelectedImageURL(this.logoList, val, "selectedLogoImageURL");
        //     },
        //     deep: true,
        // },
        // format: {
        //     handler: function (val, oldVal) {
        //         this.calculateFormat(val);
        //         resizeBoxEl(val);
        //     },
        // },
        menuName: {
            handler: function (val, oldVal) {
                this.isDraftSaveActive = Boolean(val);
            },
            deep: true,
        },
        surfaceImageId: {
            handler: function (val, oldVal) {
                this.getSelectedImageURL(this.surfaceImageList, val, "selectedSurfaceImageURL");
            },
            deep: true,
        },
        dishId: {
            handler: function (val, oldVal) {
                this.getSelectedImageURL(this.dishList, val, "selectedDishImageURL");
                this.getSelectedElementName(this.dishList, this.dishId, "selectedDishName");
            },
            deep: true,
        },
        snackId: {
            handler: function (val, oldVal) {
                this.getSelectedImageURL(this.snackList, val, "selectedSnackImageURL");
                this.getSelectedElementName(this.snackList, this.snackId, "selectedSnackName");
            },
            deep: true,
        },
        drinkId: {
            handler: function (val, oldVal) {
                this.getSelectedImageURL(this.drinkList, val, "selectedDrinkImageURL");
                this.getSelectedElementName(this.drinkList, this.drinkId, "selectedDrinkName");
            },
            deep: true,
        },
        logoId: {
            handler: function (val, oldVal) {
                this.getSelectedImageURL(this.logoList, val, "selectedLogoImageURL");
                this.getSelectedElementName(this.logoList, this.logoId, "selectedLogoName");
            },
            deep: true,
        },
        secondLogoId: {
            handler: function (val, oldVal) {
                this.getSelectedImageURL(this.logoList, val, "selectedSecondLogoImageURL");
                this.getSelectedElementName(this.logoList, this.secondLogoId, "selectedLogoName");
            },
            deep: true,
        },
        format: {
            handler: function (val, oldVal) {
                this.calculateFormat(val);
                resizeBoxEl(val);
            },
        },
        openNameDialog: {
            handler: function (val, oldVal) {
                if (this.menuName) {
                    this.isDraftSaveActive = true;
                }
            },
        },
    },

    vuetify: new Vuetify(VUETIFY_OPTIONS),
});

function GetScaleFactor(maxOutputWidth, maxOutputHeight, width, height) {
    let scale = 1;

    if (width > height) {
        scale = maxOutputWidth / width;
    } else {
        scale = maxOutputHeight / height;
    }

    return scale;
}

Number.prototype.padLeft = function (base, chr) {
    var len = String(base || 10).length - String(this).length + 1;
    return len > 0 ? new Array(len).join(chr || "0") + this : this;
};

var getFilenameFromPath = function (str) {
    var res
    if (str) {
        res = str.substring(str.lastIndexOf("/") + 1).split("?")[0];
    } else {
        res = ""
    }
    return res;
};

// Helper square
function calculateMenuPreview() {
    var menuPreview = $('#menu_preview')
    var menuPreviewHeight = menuPreview.outerHeight()
    var menuPreviewWidth = menuPreview.width()
    // check orientation fo menu_preview
    console.log("menuPreviewHeight: ", menuPreviewHeight)
    console.log("menuPreviewWidth: ", menuPreviewWidth)

    return {h: menuPreviewHeight, w: menuPreviewWidth}
}

function calculateHelperSquare() {
    var helperSquare = $('#helper_square')

    var helperSquareWidthHeight;
    var menuPreviewMeasures = calculateMenuPreview()
    console.log("menuPreviewMeasures.h: ", menuPreviewMeasures.h)
    console.log("menuPreviewMeasures.w: ", menuPreviewMeasures.w)
    if (menuPreviewMeasures.h > menuPreviewMeasures.w) {
        helperSquareWidthHeight = menuPreviewMeasures.w
    } else {
        helperSquareWidthHeight = menuPreviewMeasures.h
    }
    helperSquare.height(helperSquareWidthHeight - 10)
    helperSquare.width(helperSquareWidthHeight - 10)
    // console.log("helperSquareWidthHeight: ", helperSquareWidthHeight)
}

// $(document).ready(function () {
//     // calculateHelperSquare()
// });

